var _circle, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEnglishFlag(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Mask group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8029_25248",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 24
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 273",
    cx: 12.5,
    cy: 12,
    r: 12,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8029_25248)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.5 0V2.82922L17.9292 9.4H24.5V14.6H17.9282L24.5 21.1718V24H21.6714L15.1 17.4286V24H9.9V17.4292L3.32922 24H0.5L0.5 21.1724L7.07236 14.6H0.5L0.5 9.4H7.07137L0.5 2.82863L0.5 0.000390625L0.500391 0L3.32822 0L9.9 6.57178V0L15.1 0V6.57236L21.6724 0L24.5 0Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.500391 0L0.5 0V0.000390625L0.500391 0Z",
    fill: "#244AAD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.32822 0L9.9 6.57178V0L3.32822 0Z",
    fill: "#244AAD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1 0V6.57236L21.6724 0L15.1 0Z",
    fill: "#244AAD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5 2.82922L17.9292 9.4H24.5V2.82922Z",
    fill: "#244AAD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5 14.6H17.9282L24.5 21.1718V14.6Z",
    fill: "#244AAD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6714 24L15.1 17.4286V24H21.6714Z",
    fill: "#244AAD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.9 24V17.4292L3.32922 24H9.9Z",
    fill: "#244AAD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.5 21.1724L7.07236 14.6H0.5L0.5 21.1724Z",
    fill: "#244AAD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.5 9.4H7.07137L0.5 2.82863L0.5 9.4Z",
    fill: "#244AAD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6515 24H24.5V23.1514L15.9486 14.6H15.1V15.4485L23.6515 24Z",
    fill: "#C02934"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5 0.8485L15.9485 9.4H15.1V8.55145L23.6514 0L24.5 0V0.8485Z",
    fill: "#C02934"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.34858 0L9.9 8.55142V9.4H9.05152L0.5 0.848481V0L1.34858 0Z",
    fill: "#C02934"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.5 23.1514L9.05145 14.6H9.9V15.4485L1.3485 24H0.5V23.1514Z",
    fill: "#C02934"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3 0L13.7 0V10.8H24.5V13.2H13.7V24H11.3V13.2H0.5V10.8H11.3V0Z",
    fill: "#C02934"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnglishFlag);
export default __webpack_public_path__ + "static/media/english-flag.ca311b9de39f06b368e7f7dfcd166e32.svg";
export { ForwardRef as ReactComponent };